module.exports = {
    treadmill: {
        scale: {
            x: '100%'
        },
        texture: '/img/partials/blobs-treadmill/treadmill.png',
        positionsY: {
            'torchGuy': '26.5%',
            'sprayGuy': '39.5%',
            'laserGuy': '72%',
            'stampGirl': '49.5%',
            'puppetsMaster': '72.2%'
        },
        scalesY: {
            'torchGuy': '11.3%',
            'sprayGuy': '7%',
            'laserGuy': '7%',
            'stampGirl': '29%',
            'puppetsMaster': '14%'
        }
    }
};



// WEBPACK FOOTER //
// ./js/objects/partials/treadmill.js